<template>
  <div>
    <section id="about" class="ptb-100">
      <div class="container" v-if="content && content.length">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 18px; margin-bottom: 80px; margin-top: -60px;">
          <el-breadcrumb-item :to="{ path: '/' }">物流工具</el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div v-html="content"></div>
      </div>
      <div class="container" style="height: 800px;" v-else>
        <i class="el-icon-loading" style="color: #409EFF; font-size: 80px; position: relative; left: 40%;"/>
      </div>
    </section>
  </div>
</template>

<script>
import {getToolInfo} from '../api/index'
export default {
  name: 'page',
  // props: {
  //   content: {
  //     type: String
  //   }
  // },
  data () {
    return {
      id: '',
      title: '',
      content: ''
    }
  },
  mounted() {
     this.id = localStorage.getItem("toolId")
     this.getToolInfo()
  },
  created(){
    
  },
  methods: {
    async getToolInfo () {
      let response = await getToolInfo(this.id)
      if (response && response.code === 0 && response.data) {
        this.title = response.data.title
        this.content = response.data.content
      } else {
        this.$message.error(response.msg)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// Page.vue?0fc22cf4